export interface IDatasetService extends ng.resource.IResourceClass<any> {
  update: Function;
}

export class DatasetService {
  public static $inject: Array<string> = ["$resource"];
  public datasetService: ng.resource.IResourceClass<any>;
  constructor(private $resource: any) {
    let datasetService = $resource(`${BASE}/api/dataset/:datasetId`, {datasetId: '@id'}, {
      update: {
        method: "PUT"
      },
      query: {
        isArray: false
      }
    })
    this.datasetService = datasetService;
    return datasetService;
  }
}
